import React from 'react';
import './Header.css';
import Logo from '../../contents/app-logo-on-light.png';

const NotificationBadge=React.lazy(() => import('../notifications/NotificationBadge'));
const ProfileBadge=React.lazy(() => import('../layout/ProfileBadge'));
const Header = ({ user, onOpenNotificationsTab }) => {
  return (
    <header className="app-header">
      <div className="header-left">
        <div className="app-logo">
          <img src={Logo} alt="CAPS+ Logo" className="logo-image" />
        </div>
      </div>
      
      <div className="header-center">
        {/* You can add breadcrumbs or search here if needed */}
      </div>
      
      <div className="header-right">
        <div className="header-actions">

          <NotificationBadge onOpenNotificationsTab={onOpenNotificationsTab} />
        {/* Other header actions */}
        </div>
        {/* <div className="notification-icon">
          <span className="notification-badge">1</span>
          🔔
        </div>*/}
        <ProfileBadge user={user} onOpenNotificationsTab={onOpenNotificationsTab} />
        {/*<div className="user-profile">
          <span className="user-email">{user?.userName || 'user@example.com'}</span>
          <div className="user-avatar">
            {user?.name?.charAt(0) || 'U'}
          </div>
        </div>*/}
      </div>
    </header>
  );
};

export default Header;